const eventActions = {
    FUNNEL_STAGE_1: "Funnel Stage 1",
    CLICK: "Click",
};

export default eventActions;
